import { render, staticRenderFns } from "./PromotionPlatformUser.vue?vue&type=template&id=cc70b67e&scoped=true&"
import script from "./PromotionPlatformUser.vue?vue&type=script&lang=js&"
export * from "./PromotionPlatformUser.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPlatformUser.vue?vue&type=style&index=0&id=cc70b67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc70b67e",
  null
  
)

export default component.exports